import { Navigate } from 'react-router-dom'
import storageUtil from '@/utils/localStorage'
import { routesMap } from '@/router/routes'
import { useLocation } from 'react-router-dom'
import utils from '@/utils/utils'

const { getLocalStorage, removeLocalStorage } = storageUtil
const { isWebview } = utils

function RouterGuard({ children }: any) {
  const location = useLocation()
  const search = location.search
  const { pathname } = location
  const token = getLocalStorage('token')
  const tempToken = sessionStorage.getItem('tempToken')
  const isTempLogin = Boolean(tempToken)
  const url = `${routesMap.Login}${search}`
  // 正常跳转：
  // 1.有token
  // 2.不是临时登录，表示非游客状态
  // 3.是临时登录，但是去的页面不是购物车和我的中心
  if (
    (token || tempToken) &&
    (!isTempLogin ||
      (isTempLogin &&
        ![routesMap.ShoppingCart, routesMap.MyCenter].includes(pathname)))
  ) {
    if (!isWebview()) {
      // token存在正常渲染
      return <>{children}</>
    }

    // 从普通企业切换到站点企业时，清除本地存储并重新登录
    try {
      const res = JSON.parse(window.webview.getAuth())
      const corpInfo = getLocalStorage('corpInfo', true)

      console.log(
        `app企业ID：${res.corpId}，本地存储企业ID：${corpInfo.corpId}`,
      )

      if (corpInfo.corpId !== res.corpId) {
        removeLocalStorage('token')
        removeLocalStorage('corpInfo')
        sessionStorage.clear()
        return <Navigate to={url} replace></Navigate>
      }

      return <>{children}</>
    } catch (error) {
      return <>{children}</>
    }
  } else {
    // token不存在，重定向到登录路由
    return <Navigate to={url} replace></Navigate>
  }
}

export default RouterGuard
